import React from "react";
import styles from "./LicenseRequiredMessage.module.css";
import { Button, Typography } from "@mui/material";

function LicenseRequiredMessage({ hasUnverifiedLicense, onVerify }) {
  return (
    <div className={styles.messageContainer}>
      <div className={styles.messageBox}>
        <Typography variant="h6" className={styles.title}>
          Your license is currently under review.
        </Typography>

        <Typography variant="body1" className={styles.bodyText}>
          Our team is currently reviewing your license. You’ll be able to manage and create agencies once it’s verified.
        </Typography>

        {hasUnverifiedLicense && (
          <Typography variant="body2" className={styles.noteText}>
            <em>
              If you submitted your license over 7 business days ago, please contact our team at <a href="mailto:Team@firstland.homes">support@firstland.homes</a> for assistance.
            </em>
          </Typography>
        )}

        <Button
          variant="contained"
          className={styles.verifyButton}
          onClick={onVerify}
        >
          View License Status
        </Button>
      </div>
    </div>
  );
}

export default LicenseRequiredMessage;